var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable, inject } from 'inversify';
import { TYPES } from '@/dependency-injection/types';
import { ApiClient } from './base-axios-client';
import { AuthService } from './auth-service';
var BaseManagementService = /** @class */ (function (_super) {
    __extends(BaseManagementService, _super);
    /**
     * Constructor
     * @param baseUrl Base URL for CRUD operations, e.g. /api/v1/management/users/
     */
    function BaseManagementService(baseUrl) {
        return _super.call(this, baseUrl) || this;
    }
    /**
     * Get the item by the unique identifier
     * @param id Unique identifier of the item to be retrieved
     * @param url URL to retrieve the item
     */
    BaseManagementService.prototype.getById = function (id, url) {
        if (url === void 0) { url = 'getById'; }
        return __awaiter(this, void 0, Promise, function () {
            var request, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        request = { Id: id };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get by id');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Unable to get by id - " + url);
                        console.error(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the item by a request object
     * @param request Request object
     * @param url Endpoint to retrieve the item
     */
    BaseManagementService.prototype.getByRequest = function (request, url) {
        if (url === void 0) { url = 'getById'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get by request');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Unable to get by request - " + url);
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all items
     * @param includeDeleted If deleted items should be included
     * @param url Endpoint to retrieve the items
     */
    BaseManagementService.prototype.getAll = function (includeDeleted, includeAllFilter, url) {
        if (includeDeleted === void 0) { includeDeleted = true; }
        if (includeAllFilter === void 0) { includeAllFilter = false; }
        if (url === void 0) { url = 'getall'; }
        return __awaiter(this, void 0, Promise, function () {
            var request, response, responseMessage, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        request = { IncludeDeleted: includeDeleted };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get records');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error("Unable to get records - " + url);
                        console.error(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all items by request
     * @param request Request object
     * @param url Endoint to retrieve the items
     */
    BaseManagementService.prototype.getAllByRequest = function (request, url) {
        if (url === void 0) { url = 'getall'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get records');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error("Unable to get records - " + url);
                        console.error(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Save the item
     * @param item Item to be saved
     * @param url Endpoint to save the item
     */
    BaseManagementService.prototype.create = function (item, url) {
        if (url === void 0) { url = 'create'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, item)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to save record');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error("Unable to save record - " + url);
                        console.error(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the item
     * @param item Item to be updated
     * @param url Endpoint to update the item
     */
    BaseManagementService.prototype.update = function (item, url) {
        if (url === void 0) { url = 'update'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, item)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to update record');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error("Unable to update record - " + url);
                        console.error(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Can the item be deleted
     * @param item Item to check to see if can be deleted
     */
    BaseManagementService.prototype.canDeleteItem = function (item) {
        return Promise.resolve(true);
    };
    /**
     * Can the item be restored
     * @param item Item to check to see if can be restored
     */
    BaseManagementService.prototype.canRestoreItem = function (item) {
        return Promise.resolve(true);
    };
    /**
     * Delete the item by the unique identifier
     * @param id Unique identifier of the item to be deleted
     * @param url URL to delete the item
     */
    BaseManagementService.prototype.deleteById = function (id, url) {
        if (url === void 0) { url = 'deleteById'; }
        return __awaiter(this, void 0, Promise, function () {
            var request, response, responseMessage, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        request = { Id: id };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to delete');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        console.error("Unable to delete - " + url);
                        console.error(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete the item by a request object
     * @param request Request object
     * @param url Endpoint to delete the item
     */
    BaseManagementService.prototype.deleteByRequest = function (request, url) {
        if (url === void 0) { url = 'delete'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to delete');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_8 = _a.sent();
                        console.error("Unable to delete - " + url);
                        console.error(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Restore the item by the unique identifier
     * @param id Unique identifier of the item to be restored
     * @param url URL to restore the item
     */
    BaseManagementService.prototype.restoreById = function (id, url) {
        if (url === void 0) { url = 'restore'; }
        return __awaiter(this, void 0, Promise, function () {
            var request, response, responseMessage, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        request = { Id: id };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to restore');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _a.sent();
                        console.error("Unable to restore - " + url);
                        console.error(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rstore the item by a request object
     * @param request Request object
     * @param url Endpoint to restore the item
     */
    BaseManagementService.prototype.restoreByRequest = function (request, url) {
        if (url === void 0) { url = 'restore'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to restore');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        console.error("Unable to restore - " + url);
                        console.error(error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If the user has permission to edit on this page
     * @param page page to check for edit permissions
     */
    BaseManagementService.prototype.canEditPage = function (page) {
        if (page === void 0) { page = ''; }
        return this.authService.isAuthorized(page, 'WRITE');
    };
    /**
     * If the user has permission to view this page
     * @param page page to check for view permissions
     */
    BaseManagementService.prototype.canViewPage = function (page) {
        if (page === void 0) { page = ''; }
        return this.authService.isAuthorized(page);
    };
    /**
     * If the user has permission to edit this section on the page
     * @param page page to check for edit permissions
     * @param section section to check for edit permissions
     */
    BaseManagementService.prototype.canEditSection = function (page, section) {
        if (page === void 0) { page = ''; }
        if (section === void 0) { section = ''; }
        return this.authService.isAuthorized(page, 'WRITE', section);
    };
    /**
     * If the user has permission to view this section
     * @param page section to check for view permissions
     */
    BaseManagementService.prototype.canViewSection = function (page, section) {
        if (page === void 0) { page = ''; }
        if (section === void 0) { section = ''; }
        return this.authService.isAuthorized(page, 'READ', section);
    };
    var _a;
    __decorate([
        inject(TYPES.AuthService),
        __metadata("design:type", typeof (_a = typeof AuthService !== "undefined" && AuthService) === "function" ? _a : Object)
    ], BaseManagementService.prototype, "authService", void 0);
    BaseManagementService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [String])
    ], BaseManagementService);
    return BaseManagementService;
}(ApiClient));
export { BaseManagementService };
